module.exports = __webpack_public_path__ + "img/livro2.230d6e47.jpg";